<!-- Multiple Forms Template -->
<ng-template #MultipleFormsTemplate>
    <div *ngIf="isFormReady">

        <!-- Loop through each form instance -->
        <div *ngFor="let formInstance of formInstances; let i = index" class="mb-1">
            <div class="card p-0">
                <div class="d-flex justify-content-end ">
                    <button type="button" class="btn btn-outline-danger btn-sm p-0 px-1" (click)="removeForm(i)"
                        *ngIf="showRemoveMultiFormButton && formInstances.length > 1">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>

                <div class="card-body p-1">
                    <form [formGroup]="formInstance.formGroup" class="row" autocomplete="off"
                        (keydown.enter)="onFormKeyDown($event)">
                        <ng-container *ngFor="let inputs of formInstance.formUIC">
                            <div *ngIf="inputs.isUIVisible === 1" [class]="inputs.wrapperClass">
                                <label *ngIf="inputs.uiInputType?.toLowerCase() != 'checkbox'"
                                    [for]="'field_' + i + '_' + inputs.dbFeildName">
                                    {{ inputs.uiLabel }}
                                    <span *ngIf="inputs.validationReq === 1" style="color: red;">*</span>
                                </label>

                                <div class="d-flex flex-column">
                                    <ng-container [ngSwitch]="inputs.uiInputType?.toLowerCase()">

                                        <!-- Text Input -->
                                        <ng-container *ngSwitchCase="'text'">
                                            <input [type]="'text'" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass"
                                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.toLowerCase() === 'readonly')" />
                                        </ng-container>

                                        <!-- Text with Blur -->
                                        <ng-container *ngSwitchCase="'textblur'">
                                            <input type="text" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass" (blur)="onFieldBlur(inputs.dbFeildName)" />
                                        </ng-container>

                                        <!-- Textarea -->
                                        <ng-container *ngSwitchCase="'textarea'">
                                            <textarea rows="4" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                class="form-control">
                                            </textarea>
                                        </ng-container>

                                        <!-- Rich Text Editor -->
                                        <ng-container *ngSwitchCase="'richtext'">
                                            <app-rich-text-editor
                                                [control]="getFormControlForInstance(formInstance, inputs.dbFeildName)"></app-rich-text-editor>
                                        </ng-container>

                                        <!-- Select Dropdown -->
                                        <ng-container *ngSwitchCase="'select'">
                                            <!-- Searchable API Select -->
                                            <ng-container
                                                *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                                <ng-select appendTo="body" [items]="inputs.data"
                                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName : 'key'"
                                                    [placeholder]="inputs.uiLabel || 'Select'"
                                                    [formControlName]="inputs.dbFeildName"
                                                    [loading]="inputs.isLoading || false" [clearable]="true"
                                                    [compareWith]="getCompareFn(inputs)"
                                                    [addTag]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem') ? getAddTagFn(inputs) : false"
                                                    (change)="onSearchSelectForInstance($event, inputs,formInstance)"
                                                    (blur)="onSearchSelectForInstance(null, inputs,formInstance)"
                                                    [searchFn]="getSearchFn(inputs)"
                                                    (search)="onSearchForInstance($event, inputs,formInstance.formGroup, formInstance)">
                                                </ng-select>
                                            </ng-container>

                                            <!-- Searchable Non-API Select (not dbquery) -->
                                            <ng-container
                                                *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() != 'api' && inputs.dataFetchType?.toLowerCase() != 'dbquery'">
                                                <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="'value'"
                                                    [bindValue]="'key'" [placeholder]="inputs.uiLabel || 'Select'"
                                                    [formControlName]="inputs.dbFeildName" [compareWith]="getCompareFn(inputs)"
                                                    [compareWith]="getCompareFn(inputs)"
                                                    [searchFn]="getSearchFn(inputs)"
                                                    (search)="onSearchForInstance($event, inputs,formInstance.formGroup, formInstance)">
                                                </ng-select>
                                            </ng-container>

                                            <!-- Non-Searchable API Select -->
                                            <ng-container
                                                *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                                <ng-select appendTo="body" [items]="inputs.data"
                                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName : 'key'"
                                                    [compareWith]="getCompareFn(inputs)"
                                                    [placeholder]="inputs.uiLabel || 'Select'"
                                                    [formControlName]="inputs.dbFeildName"
                                                    [loading]="inputs.isLoading || false"
                                                    (change)="onSelectChangeForInstance($event, inputs , formInstance)">
                                                </ng-select>
                                            </ng-container>

                                            <!-- Non-Searchable Non-API (ValueList or normal) -->
                                            <ng-container
                                                *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() != 'api' && inputs.dataFetchType?.toLowerCase() != 'dbquery'">
                                                <ng-container
                                                    *ngIf="inputs.dataFetchType?.toLowerCase() === 'valuelist'; else normalSelect">
                                                    <app-valuelist-selector
                                                        [control]="getFormControlForInstance(formInstance, inputs.dbFeildName)"
                                                        [allowAddingItem]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem')"
                                                        [vlCode]="inputs.dataFetchFrom!">
                                                    </app-valuelist-selector>
                                                </ng-container>

                                                <ng-template #normalSelect>
                                                    <select [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                        [formControlName]="inputs.dbFeildName" class="form-control">
                                                        <option [value]="null">Select {{ inputs.uiLabel }}</option>
                                                        <option *ngFor="let item of inputs.data" [value]="item.key">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </ng-template>
                                            </ng-container>

                                            <!-- DB Query Select -->
                                            <ng-container *ngIf="inputs.dataFetchType?.toLowerCase() == 'dbquery'">
                                                <ng-select appendTo="body" [items]="inputs.data"
                                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName : 'key'"
                                                    [compareWith]="getCompareFn(inputs)"
                                                    [placeholder]="inputs.uiLabel || 'Select'"
                                                    [formControlName]="inputs.dbFeildName"
                                                    [loading]="!!inputs.isLoading"
                                                    [searchFn]="getSearchFn(inputs)"
                                                    (search)="dynamicQueryForInstance($event, inputs, formInstance)"
                                                    (change)="onSelectChangeForInstance($event, inputs, formInstance)">
                                                </ng-select>
                                            </ng-container>
                                        </ng-container>

                                        <!-- Password -->
                                        <ng-container *ngSwitchCase="'password'">
                                            <input type="password" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" autocomplete="new-password"
                                                [formControlName]="inputs.dbFeildName" [class]="inputs.uiClass" />
                                        </ng-container>

                                        <!-- Email -->
                                        <ng-container *ngSwitchCase="'email'">
                                            <input type="email" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass" />
                                        </ng-container>

                                        <!-- Telephone -->
                                        <ng-container *ngSwitchCase="'tel'">
                                            <input type="tel" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass" />
                                        </ng-container>

                                        <!-- Number Input -->
                                        <ng-container *ngSwitchCase="'number'">
                                            <input type="number" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass" min="0"
                                                (focus)="onNumberFocus(inputs.dbFeildName)"
                                                (blur)="onNumberBlur(inputs.dbFeildName)"
                                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.toLowerCase() === 'readonly')" />
                                        </ng-container>

                                        <!-- Date Input -->
                                        <ng-container *ngSwitchCase="'date'">
                                            <input type="date" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                [placeholder]="inputs.uiLabel" [formControlName]="inputs.dbFeildName"
                                                [class]="inputs.uiClass"
                                                [max]="inputs.validationPattern === 'noFutureDate' ? getTodayDate() : ''"
                                                [min]="inputs.validationPattern === 'noPastDate' ? getTodayDate() : ''"
                                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'readonly')">
                                        </ng-container>

                                        <!-- Checkbox -->
                                        <ng-container *ngSwitchCase="'checkbox'">
                                            <div class="d-flex align-items-center mt-3 gap-2">
                                                <input type="checkbox" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                    [checked]="formInstance.formGroup.get(inputs.dbFeildName)?.value == 1"
                                                    class="form-check-input"
                                                    (change)="onCheckBoxChange($event, inputs.dbFeildName, formInstance.formGroup)" />
                                                <label class="form-check-label"
                                                    [for]="'field_' + i + '_' + inputs.dbFeildName">
                                                    {{ inputs.uiLabel }}
                                                </label>
                                            </div>
                                        </ng-container>

                                        <!-- Toggle (Tax/Discount) -->
                                        <ng-container *ngSwitchCase="'toggle'">
                                            <ng-container *ngIf="inputs.dbFeildName.toLowerCase() === 'tax'">
                                                <div class="d-flex flex-wrap align-items-start">
                                                    <div class="flex-shrink-0">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox"
                                                                [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                                [checked]="showTax"
                                                                (change)="handleToggleSwitch(inputs.dbFeildName)">
                                                        </div>
                                                    </div>
                                                    <div *ngIf="showTax" class="flex-grow-1" style="min-width: 0;">
                                                        <app-uic-tax [FormGroup]="formInstance.formGroup"
                                                            [dependentOn]="inputs.dependentOn!">
                                                        </app-uic-tax>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="inputs.dbFeildName.toLowerCase() === 'discount'">
                                                <div class="d-flex flex-wrap align-items-start">
                                                    <div class="flex-shrink-0">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox"
                                                                [id]="'field_' + i + '_discount'"
                                                                [checked]="showDiscount"
                                                                (change)="handleToggleSwitch(inputs.dbFeildName)">
                                                        </div>
                                                    </div>
                                                    <div *ngIf="showDiscount" class="flex-grow-1" style="min-width: 0;">
                                                        <app-uic-discount [FormGroup]="formInstance.formGroup"
                                                            [dependentOn]="inputs.dependentOn!">
                                                        </app-uic-discount>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>

                                        <!-- File Upload -->
                                        <ng-container *ngSwitchCase="'file'">
                                            <div class="mb-2">
                                                <input type="file" [id]="'field_' + i + '_' + inputs.dbFeildName"
                                                    (change)="onFileSelected($event, inputs.dbFeildName)"
                                                    [accept]="'*/*'" class="form-control" />
                                            </div>
                                        </ng-container>

                                        <!-- Image Upload -->
                                        <ng-container *ngSwitchCase="'image'">
                                            <div class="mb-2">
                                                <input type="file" #fileInput hidden [accept]="'image/*'"
                                                    (change)="onImageFileSelected($event, inputs.dbFeildName)" />

                                                <div (click)="fileInput.click()" class="img-upload-preview"
                                                    style="cursor: pointer;">
                                                    <ng-container
                                                        *ngIf="getImageSrc(inputs.dbFeildName).trim(); else UploadIcon">
                                                        <img [src]="getImageSrc(inputs.dbFeildName)"
                                                            class="img-thumbnail w-100"
                                                            style="height: 150px; object-fit: contain;" />
                                                    </ng-container>
                                                    <ng-template #UploadIcon>
                                                        <div class="uploadBox">
                                                            <i class="fa fa-cloud-upload"></i>
                                                        </div>
                                                    </ng-template>
                                                </div>

                                                <div class="progress mt-2" *ngIf="uploadProgress[inputs.dbFeildName] !== undefined">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width.%]="uploadProgress[inputs.dbFeildName]"
                                                        [attr.aria-valuenow]="uploadProgress[inputs.dbFeildName]" aria-valuemin="0"
                                                        aria-valuemax="100">
                                                        {{ uploadProgress[inputs.dbFeildName] }}%
                                                    </div>
                                                </div>

                                                <input type="text" class="form-control form-control-sm mt-1"
                                                    placeholder="Upload or paste image URL"
                                                    [formControlName]="inputs.dbFeildName" />
                                            </div>
                                        </ng-container>

                                        <!-- Document Upload -->
                                        <ng-container *ngSwitchCase="'document'">
                                            <div class="mb-2">
                                                <div class="col-md-12">
                                                    <div class="input-group">
                                                        <input type="file" [id]="'field_' + i + '_docInput'"
                                                            class="form-control"
                                                            (change)="onFileSelected($event, inputs.dbFeildName)"
                                                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" />

                                                        <button *ngIf="getImageSrc(inputs.dbFeildName)" type="button"
                                                            class="btn btn-outline-secondary"
                                                            (click)="previewDocument(getImageSrc(inputs.dbFeildName))">
                                                            <i class="fa fa-eye"></i>
                                                        </button>
                                                    </div>

                                                    <div class="progress mt-2" *ngIf="uploadProgress[inputs.dbFeildName] !== undefined">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width.%]="uploadProgress[inputs.dbFeildName]"
                                                        [attr.aria-valuenow]="uploadProgress[inputs.dbFeildName]" aria-valuemin="0"
                                                        aria-valuemax="100">
                                                        {{ uploadProgress[inputs.dbFeildName] }}%
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- Button -->
                                        <ng-container *ngSwitchCase="'button'">
                                            <div class="mb-2">
                                                <button class="btn btn-sm btn-primary">Add</button>
                                            </div>
                                        </ng-container>

                                        <!-- Select N Add -->
                                        <ng-container *ngSwitchCase="'selectnadd'">
                                            <div class="row" [ngClass]="{'readonly-overlay': disabledSelectNAddField}">
                                                <div class="col-md-9">
                                                    <ng-container *ngIf="inputs.dataFetchType?.toLowerCase() == 'dbquery'">
                                                        <ng-select appendTo="body"  [items]="inputs.data"
                                                            [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                                            [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName : 'key'"
                                                            [compareWith]="getCompareFn(inputs)"
                                                            [placeholder]="inputs.uiLabel || 'Select'"
                                                            [formControlName]="inputs.dbFeildName"
                                                            [loading]="!!inputs.isLoading"
                                                            [searchable]="inputs.searchable == 1"
                                                            [searchFn]="getSearchFn(inputs)"
                                                            (search)="dynamicQueryForInstance($event, inputs, formInstance)"
                                                            (change)="onSelectChangeForInstance($event, inputs , formInstance)">
                                                        </ng-select>
                                                    </ng-container>
                                                    <ng-container *ngIf="inputs.dataFetchType?.toLowerCase() != 'dbquery'">
                                                        <ng-select  appendTo="body"  [items]="inputs.data"
                                                            [bindLabel]="inputs.displayPropertyName || 'value'"
                                                            [bindValue]="inputs.patchPropertyName || 'key'"
                                                            [placeholder]="inputs.uiLabel || 'Select'"
                                                            [formControlName]="inputs.dbFeildName"
                                                            [loading]="inputs.isLoading || false"
                                                            [searchable]="inputs.searchable == 1"
                                                            [searchFn]="getSearchFn(inputs)"
                                                            (search)="onSearchForInstance($event, inputs,formInstance.formGroup, formInstance)"
                                                            (change)="onSelectChangeForInstance($event, inputs , formInstance)">
                                                        </ng-select>
                                                    </ng-container>
                                                </div>
                                                <div class="col-md-3">
                                                    <button class="btn btn-sm btn-primary"
                                                        (click)="handleSelectNadd(inputs, formInstance)">Add</button>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- Search N Add -->
                                        <ng-container *ngSwitchCase="'searchnadd'">
                                            <div class="row">
                                                <div class="col-md-9">
                                                    <ng-select appendTo="body" [items]="inputs.data"
                                                        [bindLabel]="inputs.displayPropertyName || 'value'"
                                                        [bindValue]="inputs.patchPropertyName || 'key'"
                                                        [placeholder]="inputs.uiLabel || 'Select'"
                                                        [formControlName]="inputs.dbFeildName"
                                                        [searchable]="inputs.searchable == 1"
                                                        [searchFn]="getSearchFn(inputs)"
                                                        (search)="onSearchForInstance($event, inputs,formInstance.formGroup, formInstance)"
                                                        (change)="onSearchSelectForInstance($event, inputs , formInstance)">
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <!-- External Contact Detail -->
                                        <ng-container *ngSwitchCase="'extcontactdetail'">
                                            <app-contact-detail [masterType]="inputs.defaultValue ?? ''"
                                                [masterId]="MasterId" [editMode]="true" [calledInUIC]="true"
                                                [consignmentForm]="inputs.otherDetails === 'consignmentForm'"
                                                (ContactDetailFormEmit)="handleContactDetails($event)">
                                            </app-contact-detail>
                                        </ng-container>

                                        <!-- External Address Detail -->
                                        <ng-container *ngSwitchCase="'extaddressdetail'">
                                            <app-address-detail [masterType]="inputs.defaultValue ?? ''"
                                                [masterId]="MasterId" [editMode]="true" [calledInUIC]="true"
                                                (AddressDetailFormEmit)="handleAddressDetails($event)">
                                            </app-address-detail>
                                        </ng-container>

                                        <!-- External Document Upload -->
                                        <ng-container *ngSwitchCase="'extdocumentupload'">
                                            <app-document-upload-master [masterType]="inputs.defaultValue ?? ''"
                                                [masterId]="MasterId" [invokedByParent]="true" [editMode]="true"
                                                (DocumentDetailDataEmit)="handleDocumentDetails($event)">
                                            </app-document-upload-master>
                                        </ng-container>

                                    </ng-container>

                                    <!-- Error Messages -->
                                    <app-form-errors
                                        [control]="getFormControlForInstance(formInstance, inputs.dbFeildName)"
                                        [fieldName]="inputs.uiLabel || 'Field'">
                                    </app-form-errors>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Address Detail View Component - Full Width (if needed in multiple forms) -->
                        <div class="col-12" *ngFor="let inputs of formInstance.formUIC">
                            <ng-container
                                *ngIf="inputs.isUIVisible === 1 && inputs.uiInputType?.toLowerCase() === 'selectnadd' && inputs.customAttribute === '[AdvinMaster].[uic].[AddressDetail]'">
                                <app-uic-address-detail-view
                                    [addressId]="formInstance.formGroup.get(inputs.dbFeildName)?.value || 0"
                                    [masterType]="inputs.defaultValue || ''"
                                    (onAddressUpdate)="handleAddressUpdate($event, inputs)"
                                    (onEditStateChange)="handleAddressEditStateChange($event)">
                                </app-uic-address-detail-view>
                            </ng-container>
                        </div>
                    </form>
                </div>
            </div>
        </div>

         <!-- Add Form Button -->
        <div class="d-flex justify-content-end mb-2" *ngIf="showAddMultiFormButton" #addFormBtnContainer>
            <button type="button" class="btn btn-primary btn-sm" (click)="addFormAndScroll()">
                <i class="fa fa-plus"></i> {{ addFormButtonLabel }}
            </button>
        </div>

    </div>

    <!-- Loading Skeleton -->
    <ng-container *ngIf="!isFormReady">
        <div class="card mb-1">
            <div class="card-header d-flex align-items-center">
                <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                <span class="ml-2">
                    <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
                </span>
            </div>
            <div class="card-body">
                <ngx-skeleton-loader count="3" width="100%" height="14px"
                    style="margin-bottom: 8px;"></ngx-skeleton-loader>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #ConfigForm>
    <form [formGroup]="gFormGroup!" class="row" *ngIf="isFormReady" (keydown.enter)="onFormKeyDown($event)"
        autocomplete="off">
        <ng-container *ngFor="let inputs of gFormUIC">
            <div *ngIf="inputs.isUIVisible === 1" [class]="inputs.wrapperClass">

                <label *ngIf="inputs.uiInputType?.toLowerCase() != 'checkbox'" [for]="inputs.dbFeildName">{{
                    inputs.uiLabel }} <span *ngIf="inputs.validationReq === 1 " style="color: red;">*</span></label>

                <div class="d-flex flex-column">

                    <ng-container [ngSwitch]="inputs.uiInputType?.toLowerCase()">

                        <ng-container *ngSwitchCase="'text'">

                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName" [class]="inputs.uiClass"
                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.toLowerCase() === 'readonly')" />

                        </ng-container>

                        <ng-container *ngSwitchCase="'textblur'">

                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName" [class]="inputs.uiClass"
                                (blur)="onFieldBlur(inputs.dbFeildName)" />

                        </ng-container>

                        <ng-container *ngSwitchCase="'textarea'">

                            <textarea rows="4" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName" class="form-control"></textarea>

                        </ng-container>

                        <ng-container *ngSwitchCase="'richtext'">
                            <app-rich-text-editor [control]="getFormControl(inputs.dbFeildName)"></app-rich-text-editor>

                        </ng-container>

                        <ng-container *ngSwitchCase="'select'">


                            <ng-container
                                *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                <ng-select appendTo="body" [items]="inputs.data"
                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                    [compareWith]="getCompareFn(inputs)"
                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName :'key'"
                                    [loading]="inputs.isLoading ?? false" placeholder="Select an option"
                                    [id]="inputs.dbFeildName" [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)"
                                    (change)="onSearchSelect($event,inputs)" (blur)="onSearchSelect(null, inputs)"
                                    [addTag]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem') ? getAddTagFn(inputs) : false"
                                    class="{{!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem') ? 'allow-add-tag' : ''}}"
                                    [formControlName]="inputs.dbFeildName"
                                    [disabled]="inputs.customAttribute?.toLowerCase() === 'readonly'">
                                </ng-select>
                            </ng-container>

                            <ng-container
                                *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'valuelist'">
                                <app-valuelist-selector [control]="getFormControl(inputs.dbFeildName!)"
                                    [allowAddingItem]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem')"
                                    [vlCode]="inputs.dataFetchFrom!"
                                    (onChange)="onSelectChange($event, inputs)"></app-valuelist-selector>
                            </ng-container>

                            <ng-container
                                *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() != 'api' && inputs.dataFetchType?.toLowerCase() != 'dbquery' && inputs.dataFetchType?.toLowerCase() != 'valuelist'">
                                <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="'value'" [bindValue]="'key'"
                                    [compareWith]="getCompareFn(inputs)" [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)"
                                    placeholder="Select an option" [id]="inputs.dbFeildName"
                                    [formControlName]="inputs.dbFeildName">
                                </ng-select>
                            </ng-container>

                            <ng-container
                                *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() != 'api' && inputs.dataFetchType?.toLowerCase() != 'dbquery'">

                                <ng-container
                                    *ngIf="inputs.dataFetchType?.toLowerCase() === 'valuelist' else normalSelect">

                                    <app-valuelist-selector [control]="getFormControl(inputs.dbFeildName!)"
                                        [allowAddingItem]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'allowaddingitem')"
                                        [vlCode]="inputs.dataFetchFrom!"
                                        (onChange)="onSelectChange($event, inputs)"></app-valuelist-selector>
                                </ng-container>

                                <ng-template #normalSelect>
                                    <select [id]="inputs.dbFeildName" [formControlName]="inputs.dbFeildName"
                                        [class]="inputs.uiClass">
                                        <option [value]="null" disabled>Select {{ inputs.uiLabel }}</option>
                                        <option *ngFor="let data of inputs.data" [value]="data.key"> {{data.value}}
                                        </option>
                                    </select>
                                </ng-template>

                            </ng-container>

                            <ng-container
                                *ngIf="inputs.searchable != 1 && (inputs.dataFetchType?.toLowerCase() == 'api' || inputs.dataFetchType?.toLowerCase() == 'dbquery' )">

                                <ng-select appendTo="body" [items]="inputs.data"
                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName :'key'"
                                    [compareWith]="getCompareFn(inputs)"
                                    [loading]="inputs.isLoading || false"
                                    placeholder="Select an option" [id]="inputs.uiId"
                                    [formControlName]="inputs.dbFeildName" (change)="onSelectChange($event,inputs)">
                                </ng-select>
                            </ng-container>

                            <ng-container *ngIf="inputs.searchable == 1 &&inputs.dataFetchType?.toLowerCase() == 'dbquery'">
                                <ng-select appendTo="body" [items]="inputs.data"
                                    [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'"
                                    [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName :'key'"
                                    [compareWith]="getCompareFn(inputs)"
                                    placeholder="Select an option" [id]="inputs.uiId"
                                    [searchable]="inputs.searchable == 1"
                                    [formControlName]="inputs.dbFeildName" [searchFn]="getSearchFn(inputs)" (search)="dynamicQuery($event, inputs)"
                                    (change)="onSelectChange($event,inputs)" [loading]="!!inputs.isLoading">
                                </ng-select>
                            </ng-container>

                        </ng-container>



                        <ng-container *ngSwitchCase="'password'">

                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                autocomplete="new-password" [formControlName]="inputs.dbFeildName"
                                [class]="inputs.uiClass" />
                        </ng-container>

                        <ng-container *ngSwitchCase="'email'">
                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName" [class]="inputs.uiClass" />

                        </ng-container>

                        <ng-container *ngSwitchCase="'checkbox'">
                            <div class="d-flex align-items-center mt-3 gap-2">
                                <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName"
                                    [checked]="this.gFormGroup.get(inputs.dbFeildName)?.value == 1"
                                    class="form-check-input" (change)="onCheckBoxChange($event,inputs.dbFeildName)" />
                                <label class="form-check-label" [for]="inputs.dbFeildName">{{ inputs.uiLabel }}</label>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'date'">

                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName!" [class]="inputs.uiClass"
                                [max]="inputs.validationPattern === 'noFutureDate' ? getTodayDate() : ''"
                                [min]="inputs.validationPattern === 'noPastDate' ? getTodayDate() : ''"
                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.trim().toLowerCase() === 'readonly')">

                        </ng-container>

                        <ng-container *ngSwitchCase="'number'">
                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName!" [class]="inputs.uiClass" min="0"
                                (focus)="onNumberFocus(inputs.dbFeildName!)" (blur)="onNumberBlur(inputs.dbFeildName!)"
                                [readonly]="!!(inputs.customAttribute && inputs.customAttribute.toLowerCase() === 'readonly')" />

                        </ng-container>

                        <ng-container *ngSwitchCase="'tel'">
                            <input [type]="inputs.uiInputType" [id]="inputs.dbFeildName" [placeholder]="inputs.uiLabel"
                                [formControlName]="inputs.dbFeildName!" [class]="inputs.uiClass">

                        </ng-container>

                        <ng-container *ngSwitchCase="'toggle'">

                            <ng-container *ngIf="inputs.dbFeildName.toLowerCase() === 'tax'">

                                <div class="d-flex flex-wrap align-items-start">
                                    <div class="flex-shrink-0">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="inputs.dbFeildName"
                                                [checked]="showTax" (change)="handleToggleSwitch(inputs.dbFeildName)">
                                        </div>
                                    </div>

                                    <div *ngIf="showTax" class="flex-grow-1" style="min-width: 0;">
                                        <app-uic-tax [FormGroup]="this.gFormGroup"
                                            [dependentOn]="inputs.dependentOn!"></app-uic-tax>
                                    </div>

                                </div>

                            </ng-container>

                            <ng-container *ngIf="inputs.dbFeildName.toLowerCase() === 'discount'">
                                <div class="d-flex flex-wrap align-items-start">
                                    <div class="flex-shrink-0">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="discount"
                                                [checked]="showDiscount"
                                                (change)="handleToggleSwitch(inputs.dbFeildName)">
                                        </div>
                                    </div>
                                    <div class="flex-grow-1" style="min-width: 0;">
                                        <ng-container *ngIf="showDiscount">
                                            <app-uic-discount [FormGroup]="gFormGroup"
                                                [dependentOn]="inputs.dependentOn!"></app-uic-discount>
                                        </ng-container>
                                    </div>
                                </div>

                            </ng-container>

                        </ng-container>

                        <!-- FILE UPLOAD -->
                        <ng-container *ngSwitchCase="'file'">
                            <div class="mb-2">
                                <!-- <label [for]="inputs.dbFeildName" class="form-label">{{ inputs.uiLabel }}</label> -->
                                <input type="file" [id]="inputs.dbFeildName"
                                    (change)="onFileSelected($event, inputs.dbFeildName)" [accept]="'*/*'"
                                    class="form-control" />
                            </div>
                        </ng-container>

                        <!-- IMAGE UPLOAD -->
                        <ng-container *ngSwitchCase="'image'">
                            <!-- <div class="mb-2">
                                <input type="file" #fileInput hidden [accept]="'image/*'"
                                    (change)="onImageFileSelected($event, inputs.dbFeildName)" />

                                <div (click)="fileInput.click()" class="img-upload-preview" style="cursor: pointer;">
                                    <ng-container *ngIf="getImageSrc(inputs.dbFeildName).trim() != ''; else UploadIcon">
                                        <img [src]="getImageSrc(inputs.dbFeildName)" class="img-thumbnail w-100"
                                            style="height: 150px; object-fit: contain;" />
                                    </ng-container>
                                    <ng-template #UploadIcon>
                                        <div class="uploadBox">
                                            <i class="fa fa-cloud-upload"></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <input type="text" class="form-control form-control-sm mt-1"
                                    placeholder="or paste image URL" [formControlName]="inputs.dbFeildName" />
                            </div> -->
                            <div class="mb-2">
                                <input type="file" #fileInput hidden [accept]="'image/*'"
                                    (change)="onImageFileSelected($event, inputs.dbFeildName)" />

                                <div (click)="fileInput.click()" class="img-upload-preview" style="cursor: pointer;">
                                    <ng-container *ngIf="getImageSrc(inputs.dbFeildName).trim(); else UploadIcon">
                                        <img [src]="getImageSrc(inputs.dbFeildName)" class="img-thumbnail w-100"
                                            style="height: 150px; object-fit: contain;" />
                                    </ng-container>
                                    <ng-template #UploadIcon>
                                        <div class="uploadBox">
                                            <i class="fa fa-cloud-upload"></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <div class="d-flex gap-2 mt-2">
                                    <button type="button" class="btn btn-sm btn-outline-primary flex-fill" 
                                        (click)="fileInput.click()">
                                        <i class="fa fa-upload"></i> Upload
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-primary flex-fill" 
                                        (click)="openCamera(inputs.dbFeildName)">
                                        <i class="fa fa-camera"></i> Camera
                                    </button>
                                </div>

                                <div class="progress mt-2" *ngIf="uploadProgress[inputs.dbFeildName] !== undefined">
                                    <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress[inputs.dbFeildName]"
                                        [attr.aria-valuenow]="uploadProgress[inputs.dbFeildName]" aria-valuemin="0" aria-valuemax="100">
                                        {{ uploadProgress[inputs.dbFeildName] }}%
                                    </div>
                                </div>

                                <input type="text" class="form-control form-control-sm mt-1"
                                    placeholder="Upload or paste image URL" [formControlName]="inputs.dbFeildName" />
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'document'">
                            <div class="mb-2">
                                <div class="col-md-12">

                                    <div class="input-group">
                                        <!-- File Input -->
                                        <input type="file" id="docInput" class="form-control"
                                            (change)="onFileSelected($event, inputs.dbFeildName)"
                                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" />

                                        <!-- Preview Button -->
                                        <button *ngIf="getImageSrc(inputs.dbFeildName)" type="button"
                                            class="btn btn-outline-secondary"
                                            (click)="previewDocument(getImageSrc(inputs.dbFeildName))">
                                            <i class="fa fa-eye"></i>
                                        </button>
                                    </div>

                                    <!-- Upload Progress -->
                                    <div *ngIf="uploadProgress[inputs.dbFeildName] !== undefined" class="mt-2">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar"
                                                [style.width.%]="uploadProgress[inputs.dbFeildName]" [attr.aria-valuenow]="uploadProgress[inputs.dbFeildName]"
                                                aria-valuemin="0" aria-valuemax="100">
                                                {{ uploadProgress[inputs.dbFeildName] }}%
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>





                        <ng-container *ngSwitchCase="'button'">
                            <div class="mb-2">
                                <button class="btn btn-sm btn-primary">Add</button>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'selectnadd'">
                            <div class="row" [ngClass]="{'readonly-overlay': disabledSelectNAddField}">
                                <div class="col-md-9">
                                    <ng-container
                                        *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                        <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="inputs.displayPropertyName"
                                            [compareWith]="getCompareFn(inputs)"
                                            [loading]="inputs.isLoading ?? false" [bindValue]="inputs.patchPropertyName"
                                            placeholder="Select an option" [id]="inputs.dbFeildName"
                                            [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)" (change)="onSelectChange($event,inputs)"
                                            [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'dbquery'">
                                        <ng-select  appendTo="body"  [items]="inputs.data" [bindLabel]="inputs.displayPropertyName && inputs.displayPropertyName.trim() != '' ? inputs.displayPropertyName : 'value'" [bindValue]="inputs.patchPropertyName && inputs.patchPropertyName.trim() != '' ? inputs.patchPropertyName : 'key'" [compareWith]="getCompareFn(inputs)" placeholder="Select an option" [id]="inputs.dbFeildName" [searchable]="inputs.searchable == 1" [formControlName]="inputs.dbFeildName" [searchFn]="getSearchFn(inputs)" (search)="dynamicQuery($event, inputs)" (change)="onSelectChange($event,inputs)" [loading]="!!inputs.isLoading">
                                        </ng-select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() != 'api' && inputs.dataFetchType?.toLowerCase() != 'dbquery'">
                                        <ng-select appendTo="body"  [items]="inputs.data" [bindLabel]="'value'" [bindValue]="'key'"
                                            [loading]="inputs.isLoading ?? false" [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)"
                                            placeholder="Select an option" [id]="inputs.dbFeildName"
                                            [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() != 'api'">
                                        <select [id]="inputs.dbFeildName" [formControlName]="inputs.dbFeildName"
                                            [class]="inputs.uiClass">
                                            <option [value]="null" disabled>Select {{ inputs.uiLabel }}</option>
                                            <option *ngFor="let data of inputs.data" [value]="data.key"> {{data.value}}
                                            </option>
                                        </select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                        <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="inputs.displayPropertyName"
                                            [compareWith]="getCompareFn(inputs)"
                                            [loading]="inputs.isLoading ?? false" [bindValue]="inputs.patchPropertyName"
                                            placeholder="Select an option" [id]="inputs.dbFeildName"
                                            [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)" [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>
                                </div>

                                <div class="col-md-3">
                                    <button class="btn btn-sm btn-primary"
                                        (click)="handleSelectNadd(inputs)">Add</button>
                                </div>

                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'searchnadd'">
                            <div class="row">
                                <div class="col-md-9">
                                    <ng-container
                                        *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() == 'api'">
                                        <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="inputs.displayPropertyName"
                                            [bindValue]="inputs.patchPropertyName" placeholder="Select an option"
                                            [id]="inputs.dbFeildName" (change)="onSearchSelect($event,inputs )"
                                            [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)" [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable == 1 && inputs.dataFetchType?.toLowerCase() != 'api'">
                                        <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="'value'" [bindValue]="'key'"
                                            [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)" placeholder="Select an option"
                                            [id]="inputs.dbFeildName" [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() != 'api'">
                                        <select [id]="inputs.dbFeildName" [formControlName]="inputs.dbFeildName"
                                            [class]="inputs.uiClass">
                                            <option [value]="null" disabled>Select {{ inputs.uiLabel }}</option>
                                            <option *ngFor="let data of inputs.data" [value]="data.key"> {{data.value}}
                                            </option>
                                        </select>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="inputs.searchable != 1 && inputs.dataFetchType?.toLowerCase() == 'api'">

                                        <ng-select appendTo="body" [items]="inputs.data" [bindLabel]="'value'" [bindValue]="'key'"
                                            placeholder="Select an option" [id]="inputs.dbFeildName"
                                            [searchFn]="getSearchFn(inputs)" (search)="onSearch($event,inputs)" [formControlName]="inputs.dbFeildName">
                                        </ng-select>
                                    </ng-container>
                                </div>

                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'extcontactdetail'">
                            <app-contact-detail [masterType]="inputs.defaultValue ?? ''" [masterId]="MasterId"
                                [editMode]="true" [calledInUIC]="true"
                                [consignmentForm]="inputs.otherDetails === 'consignmentForm'"
                                (ContactDetailFormEmit)="handleContactDetails($event)"></app-contact-detail>
                        </ng-container>

                        <ng-container *ngSwitchCase="'extaddressdetail'">
                            <app-address-detail [masterType]="inputs.defaultValue ?? ''" [masterId]="MasterId"
                                [editMode]="true" [calledInUIC]="true"
                                (AddressDetailFormEmit)="handleAddressDetails($event)"></app-address-detail>
                        </ng-container>

                        <ng-container *ngSwitchCase="'extdocumentupload'">
                            <app-document-upload-master [masterType]="inputs.defaultValue ?? ''" [masterId]="MasterId"
                                [invokedByParent]="true" [editMode]="true"
                                (DocumentDetailDataEmit)="handleDocumentDetails($event)">
                            </app-document-upload-master>
                        </ng-container>
                        
                        <ng-container *ngSwitchCase="'billingdeliveryaddress'">
                          <app-uic-billing-delivery-address
                            [masterId]="inputs.dependentOn ? gFormGroup.get(inputs.dependentOn)?.value : MasterId"
                            [masterType]="inputs.defaultValue || ''"
                            [billingAddressId]="gFormGroup.get(inputs.patchDataInto!.split(',')[0].trim())!.value || ''"
                            [deliveryAddressId]="gFormGroup.get(inputs.patchDataInto!.split(',')[1].trim())!.value || ''"
                            (onAddressChange)="handleAddressChange($event, inputs)">
                          </app-uic-billing-delivery-address>
                        </ng-container>
                        
                    </ng-container>

                    <app-form-errors [control]="getFormControl(inputs.dbFeildName!)"
                        [fieldName]="inputs.uiLabel!"></app-form-errors>
                </div>






            </div>
        </ng-container>

        <!-- 
        Company Info Div Here
            <div class="col-md-12">
                <div style="width:100%; height: 100px;border: 1px solid black;">
                    company data
                </div>
            </div> 
        -->

        <!-- Address Detail View Component - Full Width -->
        <div class="col-12" *ngFor="let inputs of gFormUIC">
            <ng-container
                *ngIf="inputs.isUIVisible === 1 && inputs.uiInputType?.toLowerCase() === 'selectnadd' && inputs.customAttribute === '[AdvinMaster].[uic].[AddressDetail]'">
                <app-uic-address-detail-view [addressId]="gFormGroup.get(inputs.dbFeildName)?.value || 0"
                    [masterType]="inputs.defaultValue || ''" (onAddressUpdate)="handleAddressUpdate($event, inputs)"
                    (onEditStateChange)="handleAddressEditStateChange($event)">
                </app-uic-address-detail-view>
            </ng-container>
        </div>

    </form>



    <ng-container *ngIf="!isFormReady">
        <div class="card mb-1">
            <div class="card-header d-flex align-items-center">
                <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                <span class="ml-2">
                    <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
                </span>
            </div>
            <div class="card-body">
                <ngx-skeleton-loader count="3" width="100%" height="14px"
                    style="margin-bottom: 8px;"></ngx-skeleton-loader>
            </div>
        </div>
    </ng-container>

</ng-template>


<!-- <ng-container *ngIf="openForm; else closedForm">
    <ng-container *ngTemplateOutlet="ConfigForm"></ng-container>
</ng-container> -->

<!-- FORM WRAPPER -->
<div [ngClass]="{ 'blur-background': isModalOpen }">
    <ng-container *ngIf="openForm; else closedForm">
        <ng-container *ngIf="enableMultipleForms; else singleForm">
            <ng-container *ngTemplateOutlet="MultipleFormsTemplate"></ng-container>
        </ng-container>
        <ng-template #singleForm>
            <ng-container *ngTemplateOutlet="ConfigForm"></ng-container>
        </ng-template>
    </ng-container>
</div>

<ng-template #closedForm>
    <div class="modal-header" *ngIf="modalHeader && modalHeader.length > 0 && showModalHeader">
        <h5 class="modal-title">{{modalHeader}}</h5>
        <button type="button" class="btn-close" *ngIf="isFormModal" (click)="onClose()"></button>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="enableMultipleForms; else singleFormModal">
            <ng-container *ngTemplateOutlet="MultipleFormsTemplate"></ng-container>
        </ng-container>
        <ng-template #singleFormModal>
            <ng-container *ngTemplateOutlet="ConfigForm"></ng-container>
        </ng-template>
    </div>

    <ng-container *ngIf="">


    </ng-container>


    <ng-content></ng-content>
    
    <!-- Custom Template Content -->
    <ng-container *ngIf="customContentTemplate">
        <ng-container *ngTemplateOutlet="customContentTemplate"></ng-container>
    </ng-container>



    <div class="modal-footer text-end" *ngIf="showFooter">
        <!-- Multiple Forms Submit -->
        <button *ngIf="enableMultipleForms" type="button" class="btn btn-primary btn-sm" 
            (click)="onSubmitMultipleForms()" [disabled]="isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
            <span>{{ isSubmitting ? 'Submitting...' : submitButtonLabel }}</span>
        </button>

        <!-- Single Form Submit -->
        <button *ngIf="!enableMultipleForms" type="button" class="btn btn-primary btn-sm" (click)="onSubmit()"
            [disabled]="isSubmitting">
            <!-- <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
            <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span> -->
            <ng-container *ngIf="isSubmitting; else submit">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <span>Submitting...</span>
            </ng-container>
            <ng-template #submit>
                <span>{{ submitButtonLabel }}</span>
            </ng-template>
        </button>

        <!-- Optional secondary submit action (e.g. "Next" to continue into a follow-up flow) -->
        <button *ngIf="!enableMultipleForms && secondaryActionButtonLabel" type="button"
            class="btn btn-outline-primary btn-sm" (click)="onSubmit(true)" [disabled]="isSubmitting">
            <span>{{ secondaryActionButtonLabel }}</span>
        </button>

        <!-- Close/Reset Button (always visible) -->
        <button class="btn btn-sm btn-secondary" (click)="onClose()">
            {{isFormModal ? 'Close' : 'Reset'}}
        </button>
    </div>
</ng-template>

<!-- Camera Modal -->
<div *ngIf="isCameraActive" class="camera-modal-overlay">
    <div class="camera-modal">
        <div class="camera-header">
            <h5>Capture Photo</h5>
            <button type="button" class="btn-close" (click)="closeCamera()" [disabled]="isCapturing"></button>
        </div>
        <div class="camera-body">
            <video id="cameraVideo" autoplay playsinline></video>
            
            <!-- Capturing Overlay -->
            <div *ngIf="isCapturing" class="capturing-overlay">
                <div class="spinner-border text-light" role="status">
                    <span class="visually-hidden">Processing...</span>
                </div>
                <p class="text-light mt-2">Processing image...</p>
            </div>
        </div>
        <div class="camera-footer">
            <button type="button" class="btn btn-primary" (click)="capturePhoto()" [disabled]="isCapturing">
                <span *ngIf="isCapturing" class="spinner-border spinner-border-sm me-1" role="status"></span>
                <i *ngIf="!isCapturing" class="fa fa-camera"></i>
                {{ isCapturing ? 'Processing...' : 'Capture' }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="closeCamera()" [disabled]="isCapturing">
                Cancel
            </button>
        </div>
    </div>
</div>